<template>
  <div>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs6>
              <v-img src="img/Metal.jpg" aspect-ratio="1.7"></v-img>
            </v-flex>
            <v-flex xs6 class="card-item">
              <v-layout row wrap>
                <v-flex xs12>
                   <v-text-field
                    name="metal_quantity"
                    label="Cantidad"
                    id="metal_quantity"
                    type="number" 
                    v-model="itemData.metal_quantity"
                    @focus="$event.target.select()"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                   <v-select
                    item-text="label"
                    item-value="value"
                    :items="metalOriginOptions"
                    v-model="itemData.metal_origin"
                    label="Origen"
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    item-text="label"
                    item-value="value"
                    :items="metalSizeOptions"
                    v-model="itemData.metal_size"
                    label="Tamaño"
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                   <v-select
                    item-text="label"
                    item-value="value"
                    :items="metalContentOptions"
                    v-model="itemData.metal_content"
                    label="Contenido"
                    outline
                  ></v-select>
                </v-flex>
                 <v-flex xs12>
                   <v-text-field
                    name="metal_price"
                    label="Precio"
                    id="metal_price"
                    type="number" 
                    v-model="itemData.metal_price"
                    @focus="$event.target.select()"
                    @keyup.enter="addItem"
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 text-xs-right>
              <v-btn color="success" @click="addItem">Agregar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      metalOriginOptions: [
        {label: 'Importado', value: 'IMPORTED'},
        {label: 'Doméstico', value: 'LOCAL'},
      ],
      metalSizeOptions: [
        {label: 'Grande', value: 'LARGE'},
        {label: 'Mediano', value: 'MEDIUM'},
        {label: 'Chico', value: 'SMALL'},
      ],
      metalContentOptions: [
        {label: 'Lleno', value: 'WHOLE'},
        {label: 'Tres cuartos', value: 'THREE_QUARTER'},
        {label: 'Media', value: 'HALF'},
        {label: 'Un cuarto', value: 'QUARTER'},
      ],
      defaultItemData: {
        metal_origin: 'IMPORTED',
        metal_size: 'LARGE',
        metal_content: 'WHOLE',
        metal_price: 0.00,
        metal_quantity: 0,
        type: 'METAL',
      },
      itemData: {
        metal_origin: 'IMPORTED',
        metal_size: 'LARGE',
        metal_content: 'WHOLE',
        metal_price: 0.00,
        metal_quantity: 0,
        type: 'METAL',
      },
    };
  },
  computed: {
  },
  methods: {
    addItem() {
      if (this.isLineValid()) {
        this.itemData.metal_price = parseFloat(this.itemData.metal_price);

        this.$emit('add-item', this.itemData);
        this.itemData = Object.assign({}, this.defaultItemData);
      } else {
        this.$emit('warning', 'Ingrese un precio pagado');
      }
    },
    isLineValid() {
      return  true;
    },
  },
};
</script>